export default "__VITE_ASSET__CGp7uQMj__"